export const EditTemplateStoreFeatureKey = 'edit-template';